export function downloadBlob(fileName: string, blobURL: string) {
  const anchor = document.createElement('a');

  document.body.appendChild(anchor);

  anchor.href = blobURL;
  anchor.download = fileName;

  anchor.click();
  anchor.remove();
}

export function getFilenameFromContentDisposition(responseHeaders: {
  'content-disposition': string;
}) {
  const contentDisposition = responseHeaders['content-disposition'];

  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
}
